import { ProjectPlanJobListComponent } from './project-plan-job-list/project-plan-job-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { LeafletMarkerClusterModule } from '@bluehalo/ngx-leaflet-markercluster';
import { BuildingPlanDetailsComponent } from './building-plan-details/building-plan-details.component';
import { BuildingPlanCompareComponent } from './building-plan-compare/building-plan-compare.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { CoreModule } from './../../../core/core.module';
import { NgModule } from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TranslatePipe } from '@ngx-translate/core';

@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        LeafletModule,
        LeafletMarkerClusterModule,
        NgSelectModule,
        ScrollingModule,
        TranslatePipe,
    ],
    declarations: [BuildingPlanDetailsComponent, ProjectPlanJobListComponent, BuildingPlanCompareComponent],
    exports: [BuildingPlanDetailsComponent, ProjectPlanJobListComponent, BuildingPlanCompareComponent],
})
export class SharedBuildingPlanDetailsModule {}
